document.addEventListener("DOMContentLoaded", () => {
    $('[data-fancybox="gallery"]').fancybox({
        infobar: false,
        caption: function (instance, item) {
            var caption = $(this).find('figaption').text() || '';

            return (caption.length ? caption + '<br />' : '') + 'Image <span data-fancybox-index></span> of <span data-fancybox-count></span>';
        }
    });

    $('#articleAside').attr('style', `padding-bottom: ${$('.article__subscription').outerHeight() + 10}px`);

    $('[data-element=articleSub]').click(function () {
        let submodalHasForm = $('#articleSubmodalBody').find('[data-element=hubpsotSub]').length > 0;
        if (!submodalHasForm) {
            const form = $('[data-element=hubpsotSub]').clone();
            $('#articleSubmodalBody').html(form);
            aFormMethods(document.getElementById('sib-form'));
        }
    })

    $('[data-p-crop]').each(function(){
        $(this).find('img').css('margin-block', $(this).attr('data-p-crop'))
    });

    $('#ukPrivateModalExchanges').modal('show');
});